import { http } from "../client";
import { mapPlaylistPreviewObject } from "./mappers";
export var getPlaylists = function (_a) {
    var title = _a.title, type = _a.type, skip = _a.skip, take = _a.take, isPublished = _a.isPublished, clientId = _a.clientId, orderBy = _a.orderBy, orderByDirection = _a.orderByDirection;
    return http.api
        .get("/playlists", {
        params: {
            title: title,
            type: type,
            skip: skip,
            take: take,
            is_published: isPublished ? 1 : 0,
            client_id: clientId,
            order_by: orderBy,
            order_by_direction: orderByDirection,
        },
    })
        .then(function (response) { return response.data; })
        .then(function (_a) {
        var _b = _a.data, items = _b.items, total = _b.total;
        return ({
            items: items.map(mapPlaylistPreviewObject),
            total: total,
        });
    });
};
